<a [routerLink]="['./']" [queryParams]="$queryParams() ?? {}">
    <div class="cm-pinned-filter" [ngClass]="{active: $isActivated()}">
        <ng-content></ng-content>
    </div>
</a>
